import type { ManagementUser } from '../data/builders/users/find-user';
import type { LookupUser } from '../data/builders/users/lookup-users';

export type UserProfile = ManagementUser | LookupUser;

export type UserIdentityFields = {
  id: string;
  email?: string;
  title?: string;
};

export function userDisplayName(user: UserIdentityFields): string {
  return user.title ?? user.email ?? user.id;
}

export function userEmail(
  user: UserIdentityFields,
  fallback: boolean = false
): string {
  return user.email ?? (fallback ? (user.title ?? user.id) : '');
}

export function profileDisplayName(profile: UserProfile): string {
  if ('email' in profile && profile.email) {
    return profile.email;
  }

  return userDisplayName(profile);
}

export function profileEmailWithFallback(profile: UserProfile): string {
  if ('email' in profile && profile.email) {
    return profile.email;
  }

  if ('title' in profile && profile.title) {
    return profile.title;
  }

  return profile.id;
}

export function isManagementUser(
  profile: UserProfile
): profile is ManagementUser {
  return 'rights' in profile;
}
